export default __webpack_public_path__ + "static/N0217-adc8e847a357223fa088c0e96fac3a96.png";